interface PaginatorProps {
	readonly pageCount: number;
	readonly pageIndex: number;
	readonly shownPages: number;
	readonly showRelative?: boolean; // Si se muestra la navegación relativa
	readonly onPageChange: (pageIndex: number) => void;

	readonly canPrevious: boolean;
	readonly canNext: boolean;
}
export function Paginator(props: PaginatorProps) {
	const {
		pageCount,
		pageIndex,
		shownPages,
		onPageChange,
		canPrevious,
		canNext,
	} = props;
	const { showRelative = true } = props;

	const navigateRelative = (delta: number) => (event: React.MouseEvent) => {
		event.preventDefault();
		const newPageIndex = pageIndex + delta;
		if (newPageIndex >= 0 && newPageIndex < pageCount) {
			onPageChange(newPageIndex);
		}
	};
	const navigateToPage = (page: number) => (event: React.MouseEvent) => {
		event.preventDefault();
		if (page >= 0 && page < pageCount) {
			onPageChange(page);
		}
	};

	return (
		<div className="paginator">
			{showRelative ? (
				<PaginationItem
					onClick={navigateRelative(-1)}
					disabled={!canPrevious}>
					<PaginationPrev />

				</PaginationItem>
			) : null}

			<Pages
				pageCount={pageCount}
				pageIndex={pageIndex}
				shownPages={shownPages}
				navigateToPage={navigateToPage}
			/>

			{showRelative ? (
				<PaginationItem
					// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion -- No es una conversion, es estilistico (+1, -1)
					onClick={navigateRelative(+1)}
					disabled={!canNext}>
					<PaginationNext />
				</PaginationItem>
			) : null}
		</div>
	);
}

function Pages(props: PagesProps) {
	const { pageCount, pageIndex, shownPages, navigateToPage } = props;

	if (pageCount == 0) {
		return (
			<PaginationItem disabled isActive>
				1
			</PaginationItem>
		);
	}

	// Show all pages if total pages is less than or equal to shownPages
	if (pageCount <= shownPages) {
		return (
			<>
				{Array.from({ length: pageCount }, (_, index) => (
					<PaginationItem
						key={index + 1}
						onClick={navigateToPage(index)}
						isActive={pageIndex === index}
					>
						{index + 1}
					</PaginationItem>
				))}
			</>
		);
	}

	const pages = [];
	const firstPage = 1;
	const lastPage = pageCount;

	const windowSize = shownPages - 2; // always show first and last
	let start = Math.max(pageIndex + 1 - Math.floor(windowSize / 2), 2);
	let end = start + windowSize - 1;

	if (end > lastPage - 1) {
		end = lastPage - 1;
		start = Math.max(end - windowSize + 1, 2);
	}

	const startEllipsis = start > 2; // Show ellipsis if there are pages before the window
	const endEllipsis = end < lastPage - 1; // Show ellipsis if there are pages after the window

	// Si hay elipsis al final, quitamos la pagina que este ocupa
	if (endEllipsis) {
		end -= 1;
	}
	// Si hay elipsis al principio, quitamos la pagina que este ocupa
	if (startEllipsis) {
		start += 1;
	}

	// First page
	pages.push(
		<PaginationItem key={firstPage} onClick={navigateToPage(0)} isActive={pageIndex === 0}>
			{firstPage}
		</PaginationItem>,
	);

	if (startEllipsis) {
		pages.push(
			<PaginationEllipsis key="start-ellipsis" />
		);
	}

	// Page window
	for (let index = start; index <= end; index++) {
		pages.push(
			<PaginationItem
				key={index}
				onClick={navigateToPage(index - 1)}
				isActive={pageIndex === index - 1}
			>
				{index}
			</PaginationItem>,
		);
	}

	// Ellipsis after window
	if (endEllipsis) {
		pages.push(
			<PaginationEllipsis key="end-ellipsis" />
		);
	}

	// Last page
	pages.push(
		<PaginationItem
			key={lastPage}
			onClick={navigateToPage(lastPage - 1)}
			isActive={pageIndex === lastPage - 1}
		>
			{lastPage}
		</PaginationItem>,
	);

	return pages;
}

interface PagesProps {
	readonly navigateToPage: (page: number) => (e: React.MouseEvent) => void;
	readonly pageIndex: number;
	readonly pageCount: number;
	readonly shownPages: number;
}


function PaginationItem(props: { readonly children: React.ReactNode; readonly onClick?: (e: React.MouseEvent) => void; readonly disabled?: boolean; readonly isActive?: boolean; }) {
	return (
		<button className={`paginateButton ${props.isActive == true ? "active" : ""}`} onClick={props.onClick} disabled={props.disabled} type="button">
			{props.children}
		</button>
	);
}
function PaginationEllipsis() {
	// return <i className="fa fa-ellipsis-h"></i>;
	return (
		<button className="paginateEllipsis" disabled type="button">
			...
		</button>
	);
}
function PaginationNext() {
	// return <i className="fa fa-chevron-right"></i>;
	return "Siguiente";
}
function PaginationPrev() {
	// return <i className="fa fa-chevron-left"></i>;
	return "Anterior";
}
// export const Paginator = memo(_Paginator);
